import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ExternalRefreshNotifierConfig, ExternalRefreshNotifierEmittedData, ExternalRefreshRequestStates, ExternalRefreshUpdateData } from '../interfaces/external-refresh-notifier';

@Injectable({
  providedIn: 'root'
})
export class ExternalRefreshNotifierService {

  notifyExternalRefreshRequired = new Subject<ExternalRefreshNotifierConfig>();
  externalRefreshUpdate = new Subject<ExternalRefreshUpdateData>();

  constructor() {}

  externalSourceRequestsRefresh(config: ExternalRefreshNotifierConfig)
  {
    this.notifyExternalRefreshRequired.next(config);
  }

  externalRefreshIsPending(data: ExternalRefreshNotifierEmittedData)
  {
    let info: ExternalRefreshUpdateData = {
      state: ExternalRefreshRequestStates.PENDING,
      details: data
    }
    this.externalRefreshUpdate.next(info);
  }

  userRequestsRefresh(data: ExternalRefreshNotifierEmittedData)
  {
    let info: ExternalRefreshUpdateData = {
      state: ExternalRefreshRequestStates.USER_REQUESTED,
      details: data
    }
    this.externalRefreshUpdate.next(info);
  }

  externalRefreshComplete(data: ExternalRefreshNotifierEmittedData)
  {
    let info: ExternalRefreshUpdateData = {
      state: ExternalRefreshRequestStates.COMPLETE,
      details: data
    }
    this.externalRefreshUpdate.next(info);
  }
}
